export const CREATE_ROUTE_SUCCESS = "CREATE_ROUTE_SUCCESS";
export const CREATE_ROUTE_FAILED = "CREATE_ROUTE_FAILED";
export const CREATE_ROUTE_PENDING = "CREATE_ROUTE_PENDING";
export const GET_TASKS_INFO = "GET_TASKS_INFO";
export const GET_TASKS_RESET = "GET_TASKS_RESET";
export const GET_TASKS_INFO_ERROR = "GET_TASKS_INFO_ERROR";
